import Button from "./button";
import ButtonGroup from "./button-group";
import middleware from "../../middleware";

Button.Group = ButtonGroup;
const Com = middleware(Button, "Button");
export default Com;



// WEBPACK FOOTER //
// ./_antd1.11.2/button/index.jsx